export class FolderUnlockRequestNotification {
	public viewId: number;
	public folderId: string;
	public folderName: string;
	public userName: string;
	public userLogin: string;

	public static fromJson(other: any): FolderUnlockRequestNotification {
		const instance = new FolderUnlockRequestNotification();
		instance.viewId = other.ViewId;
		instance.folderId = other.FolderId;
		instance.folderName = other.FolderName;
		instance.userName = other.UserDisplayName;
		instance.userLogin = other.UserLogin;
		return instance;
	}
}
